import React from 'react';
import { useNavigate } from 'react-router-dom';

const isModifiedClick = (event, target) =>
  event.button !== 0 ||
  event.metaKey ||
  event.altKey ||
  event.ctrlKey ||
  event.shiftKey ||
  (target && target !== '_self');

/**
 * An anchor that preserves a complete viewer URL for native browser actions,
 * while using the in-memory router for ordinary same-tab clicks.
 * @param {object} props Props accepted by the component.
 * @param {string} props.to In-memory router destination.
 * @param {string} props.href Native browser destination.
 * @returns {import('react').FunctionComponent} A viewer link.
 */
const ViewerLink = React.forwardRef(
  ({ to, href, target, onClick, children, ...props }, ref) => {
    const navigate = useNavigate();

    const handleClick = (event) => {
      onClick?.(event);
      if (
        event.defaultPrevented ||
        isModifiedClick(event, target) ||
        typeof to !== 'string'
      ) {
        return;
      }

      event.preventDefault();
      navigate(to);
    };

    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <a {...props} ref={ref} href={href} target={target} onClick={handleClick}>
        {children}
      </a>
    );
  },
);

ViewerLink.displayName = 'ViewerLink';

export default ViewerLink;
